export const MISSINGPROMPTS_REQUEST = "MISSINGPROMPTS_REQUEST";
export const MISSINGPROMPTS_SUCCESS = "MISSINGPROMPTS_SUCCESS";
export const MISSINGPROMPTS_FAILURE = "MISSINGPROMPTS_FAILURE";